import type { DomainGuid, GridElementTypes } from '../..';
import type { AttentionStatusType } from '../../evaluation/AttentionStatus';
import type { GridElementLoadFlowDetails } from '../gridElementsDetailsByCalculationType/loadFlow/gridElementLoadFlowDetails.types';
import type { GridElementShortCircuitDetails } from '../gridElementsDetailsByCalculationType/shortCircuit/ShortCircuitDetails';
import { selectHigherAttentionStatus } from './selectHigherAttentionStatus';

export class GridElement implements GridElementType {
  static FromDetails(
    details: GridElementLoadFlowDetails | GridElementShortCircuitDetails,
    status: AttentionStatusType
  ): GridElementType {
    return {
      id: details.id,
      label: details.label,
      objectType: details.objectType,
      status
    };
  }

  private constructor(
    public readonly id: DomainGuid,
    public readonly label: string,
    public readonly objectType: GridElementTypes,
    public readonly status: AttentionStatusType
  ) {}

  public copyWithHigherAttentionStatus(
    status: AttentionStatusType
  ): GridElement {
    const higherAttentionStatus = selectHigherAttentionStatus(
      this.status,
      status
    );
    return new GridElement(
      this.id,
      this.label,
      this.objectType,
      higherAttentionStatus
    );
  }

  public static Create(mapElement: GridElementType): GridElement {
    return new GridElement(
      mapElement.id,
      mapElement.label,
      mapElement.objectType,
      mapElement.status
    );
  }
}

export type GridElementType = {
  id: DomainGuid;
  label: string;
  objectType: GridElementTypes;
  status: AttentionStatusType;
};
